import React, { useEffect, useState } from 'react';
import { getBrand } from '../helpers';
import { useConfig } from '../hooks';

export const BrandContext = React.createContext<string | undefined>(undefined);

export const BrandProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const [brand, setBrand] = useState<string>();

    const { brandParentUrl } = useConfig();

    useEffect(() => {
        const brand = getBrand(brandParentUrl);
        setBrand(brand);
    }, []);

    return (
        <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>
    );
};
